import * as React from 'react';
import s from './Navbar.module.scss';
import { MenuItem } from '../../types';
import { DynamicLink } from '../shared/components';
import Text from '../shared/Text';

interface Props {
  menuTitle?: string;
  menuItems: MenuItem[];
  baseUrl: string;
  onClick?: () => void;
  large?: boolean;
  hiddenDesktop?: boolean;
  itemsClasses?: string;
}

class NavbarMenuGroup extends React.Component<Props> {
  renderText = (title: string) => {
    const { large } = this.props;
    if (large) {
      return (
        <Text h4 light>
          {title}
        </Text>
      );
    }

    return <div className={s.menuLink}>{title}</div>;
  };

  render() {
    const {
      menuTitle,
      menuItems,
      baseUrl,
      onClick,
      hiddenDesktop,
      itemsClasses,
    } = this.props;
    return (
      <div className={`d-block ${hiddenDesktop ? 'd-md-none' : null}`}>
        {menuTitle && <div className={s.menuTitle}>{menuTitle}</div>}
        <div className={itemsClasses}>
          {menuItems &&
            menuItems.map(({ title, url }) => (
              <DynamicLink
                to={url.replace(baseUrl, '')}
                key={url}
                onClick={() => onClick && onClick()}
              >
                {this.renderText(title)}
              </DynamicLink>
            ))}
        </div>
      </div>
    );
  }
}
export default NavbarMenuGroup;
